import React from 'react';

import { Flex } from '@rover/kibble/core';
import Footer, { type FooterProps } from '@rover/react-lib/src/pages/shared/FooterLinks/Footer';

import { PageSectionId, useSectionRef } from '../../SeoLocation/hooks/useSectionRef';

type Props = FooterProps;

const ServiceLandingFooterLinks: React.FC<Props> = (footerProps) => {
  const sectionRef = useSectionRef(PageSectionId.Footer);

  return (
    <Flex htmlRef={sectionRef} flexDirection="column">
      <Footer {...footerProps} />
    </Flex>
  );
};

export default ServiceLandingFooterLinks;
